import { ApiService } from '../apiService'
import type {
  SubscriptionPlanDto,
  UserSubscriptionDto,
  PaymentHistoryResponse,
  UserCreditsResponse,
  AdminSubscriptionCreditDto,
  GrantCreditRequest,
  AdminUserSubscriptionDto,
  AdminSetUserSubscriptionRequest,
} from '../types/subscription'

export const subscriptionsApi = {
  // Get all subscription plans (public endpoint)
  getPlans: () => ApiService.get<SubscriptionPlanDto[]>('/api/subscription-plans'),

  // Get a specific plan by ID (public endpoint)
  getPlan: (id: string) => ApiService.get<SubscriptionPlanDto>(`/api/subscription-plans/${id}`),

  // Get current user's subscription (creates free tier if none exists)
  getCurrentSubscription: () => ApiService.get<UserSubscriptionDto>('/api/me/subscription'),

  // Get user's payment history with pagination
  getPaymentHistory: (page: number = 1, pageSize: number = 20) =>
    ApiService.get<PaymentHistoryResponse>('/api/me/payments', { page, pageSize }),

  // ==================
  // USER CREDITS
  // ==================

  // Get user's available credits
  getMyCredits: () => ApiService.get<UserCreditsResponse>('/api/me/credits'),

  // Redeem a credit
  redeemCredit: (creditId: string) =>
    ApiService.post<UserSubscriptionDto>(`/api/me/credits/${creditId}/redeem`),

  // ==================
  // ADMIN CREDITS
  // ==================

  // Grant credit to a user (admin only)
  grantCredit: (data: GrantCreditRequest) =>
    ApiService.post<AdminSubscriptionCreditDto>('/admin/subscription-credits', data),

  // Get a user's PENDING credits (admin only).
  // The endpoint returns the same summary object as /api/me/credits, not a bare array — typing it
  // as an array made every admin credit list render empty.
  getUserCredits: (userId: string) =>
    ApiService.get<UserCreditsResponse>(`/admin/subscription-credits/user/${userId}`),

  // Revoke a pending credit (admin only)
  revokeCredit: (creditId: string) =>
    ApiService.delete<void>(`/admin/subscription-credits/${creditId}`),

  // ==================
  // ADMIN SUBSCRIPTION OVERRIDE
  // ==================

  // Read a user's subscription and what their plan currently entitles them to
  getUserSubscription: (userId: string) =>
    ApiService.get<AdminUserSubscriptionDto>(`/admin/users/${userId}/subscription`),

  // Put a user on a plan for a stated term. Selecting the free-tier plan downgrades them.
  setUserSubscription: (userId: string, request: AdminSetUserSubscriptionRequest) =>
    ApiService.put<AdminUserSubscriptionDto>(`/admin/users/${userId}/subscription`, request),
}
